module.exports = __webpack_public_path__ + "static/media/game-cvinterviewericon15.c6413d69.png";